import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { setKey, session } from "../store/actions";
import { connect } from "react-redux";
import { swalSuccess } from "../utils/swal";
import settingService from '../services/setting';
import Switch from "react-switch";

function ManageCurrencyExchange({
    session,
    setKey,
    ...props
}) {
    const { t } = useTranslation();
    const [show, setShow] = useState(true);

    useEffect(() => {
        settingService.get()
            .then(response => {
                if (response && response.data) {
                    setShow(response.data.showCurrencyExchange);
                }
            });
    }, []);

    const handleOnChange = checked => {
        setShow(checked);
        save(checked);
    }

    const save = (val) => {
        settingService.updateCurrencyExchange(session.token, val)
            .then(response => {
                swalSuccess(t("setting_updated"));
            });
    }

    return (
        <div className="container">
            <div className="row mt-10">
                <div className="col text-left">
                    <h3>{t("manage_currency_title")}</h3>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <p>{t("currency_desc")}</p>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <Switch onChange={handleOnChange} checked={show} />
                    <br />
                    {show && <p style={{ color: 'green' }}>{t("currency_visible")}</p>}
                    {!show && <p style={{ color: 'red' }}>{t("currency_hidden")}</p>}
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = store => ({
    session: store.session
});

const mapDispatchToProps = dispatch => ({
    setKey: (key, value) => dispatch(setKey(key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageCurrencyExchange);
